const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");

module.exports = createReactClass({
	displayName: "PageBackdropImage",

	propTypes: {
		imageSrc: PT.string.isRequired,
		imageStyle: PT.string.isRequired,
	},

	render: function() {
		const image =
			this.props.imageSrc && this.props.imageStyle ? (
				<img className={this.props.imageStyle} src={this.props.imageSrc} />
			) : null;

		return <React.Fragment>{image}</React.Fragment>;
	},
});
